
function openCart() {
  var cart = document.getElementById('vowlsCart');
  document.getElementById('discountAmount').innerHTML = '';
    document.getElementById('discountPrice').innerHTML = '';
    cart.classList.remove('tw-hidden');
    cart.classList.remove('!tw-w-0');

    updateCart();
    checkCart();
}

function closeCart() {
    var cart = document.getElementById('vowlsCart');
        cart.classList.add('!tw-w-0');
        cart.classList.add('tw-hidden');
}




async function reduceItemQuantity(id, quantity) {
    var newQuantity = quantity - 1;
    let formData = {
        updates: {
          [id]: newQuantity
        }
      };
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(async data => {
        document.getElementById('productHolder').innerHTML = '<div class="lds-dual-ring"></div>';
        await updateCart();
        checkCart();
    });
}
async function addItemQuantity(id, quantity) {
    var newQuantity = quantity + 1;
    let formData = {
        updates: {
          [id]: newQuantity
        }
      };
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(async data => {
        document.getElementById('productHolder').innerHTML = '<div class="lds-dual-ring"></div>';
        await updateCart();
        await updateCartProgressBar();
        checkCart();
    });
}

async function removeItem(id, quantity){
    let formData = {
        updates: {
          [id]: 0
        }
      };
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(async data => {
        document.getElementById('productHolder').innerHTML = '<div class="lds-dual-ring"></div>';
        await updateCart();
        checkCart();
    });
}

async function updateCart() {
    document.getElementById('productHolder').innerHTML = '<div class="lds-dual-ring"></div>';
    // get cart.js from shpoify and iterate over the result
   await fetch('/cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    })
    .then(response => response.json())
    .then(async data => {
        data.items.forEach(item => {
            var imgUrl = ''
            if (item.handle === "killa-lentilla"){
              imgUrl = 'https://cdn.shopify.com/s/files/1/0551/0807/5715/files/KillaLentilla.png?v=1676452090'
            }
            else if (item.handle === "easy-peasy"){
              imgUrl = 'http://eatvowls.myshopify.com/cdn/shop/files/take_it_peasy_LOGO_small.png?v=1708084370'

            }
            else if (item.handle === "i-have-a-bean"){
              imgUrl = 'https://cdn.shopify.com/s/files/1/0551/0807/5715/files/Naming_1.png?v=1677574975'
            }

            document.getElementById('productHolder').innerHTML += `<div class="tw-flex tw-flex-row tw-border-0 tw-border-b tw-border-white tw-border-solid tw-pb-3 tw-bg-vowlsBgLight tw-p-5">
            <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-[40%]">
              <div>
                <img
                  src="${item.featured_image.url}"
                  width="112"
                  height="112"
                  alt="">
              </div>
              <div class="tw-flex tw-flex-row tw-justify-between tw-items-center tw-w-full tw-pl-5">
                <img
                  src="https://cdn.shopify.com/s/files/1/0551/0807/5715/files/minusBlack.png?v=1676557230"
                  alt=""
                  class="tw-w-[12px] tw-py-2"
                  onclick="reduceItemQuantity(${item.variant_id}, ${item.quantity})">
                <p>${item.quantity}</p>
                <img
                  src="https://cdn.shopify.com/s/files/1/0551/0807/5715/files/plusBlack.png?v=1676557230"
                  alt=""
                  class="tw-w-[12px]"
                  onclick="addItemQuantity(${item.variant_id}, ${item.quantity})">
                <img
                  src="https://cdn.shopify.com/s/files/1/0551/0807/5715/files/bin.png?v=1676557229"
                  class="tw-w-[13px]"
                  onclick="removeItem(${item.variant_id}, ${item.quantity})"
                  alt="">
              </div>
            </div>
            <div class="tw-flex tw-flex-row ">


              <div class="tw-flex tw-flex-row tw-items-start tw-mt-3">

              <img
                  src="${imgUrl}"
                  alt=""
                  width="55"
                  class="tw-h-auto tw-mr-5">
              </div>
              <div class="tw-flex tw-flex-col tw-justify-between tw-mt-5 tw-pl-3">
                <div>

                  <p class="tw-text-[13px] tw-text-black tw-font-CeraProRegularBold tw-m-0">
                    ${item.title}
                  </p>

                </div>
                <div>

                  <p class="tw-text-[13px] tw-text-black tw-font-CeraProRegularBold tw-m-0">
                    ${(new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(item.price * item.quantity/ 100))}</p>

                </div>
              </div>
            </div>
          </div>`;
        });
        await updateCartProgressBar();

    });

}


async function checkCart() {

  await fetch('/cart.js', {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
    }
})
.then(response => response.json())
.then( data => {
  if( data.items_subtotal_price >= 1497){
    document.getElementById('cartButton').href = '/checkout';
    document.getElementById('cartButtonInner').innerHTML = 'Zur Kasse'}
  else {
    document.getElementById('cartButton').href = '/collections/all';
    document.getElementById('cartButtonInner').innerHTML = 'Mindestbestellmenge 3 Vowls';
  }

  // if(data.item_count === 0){
  //   document.getElementById('subtotalPrice').innerHTML = (new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(data.total_price / 100));
  //   document.getElementById('cartButton').href = '/collections/all';
  //   document.getElementById('cartButtonInner').innerHTML = 'Mindestbestellmenge 3 Vowls';
  //   document.getElementById('discountAmount').innerHTML = '';
  //   document.getElementById('discountPrice').innerHTML = '';
  // } else if(data.item_count >= 6 && data.item_count < 12){
  //     document.getElementById('subtotalPrice').innerHTML = (new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(data.total_price * 0.9498998 / 100));
  //     document.getElementById('discountAmount').innerHTML = '5% Mengenrabatt';
  //     document.getElementById('discountPrice').innerHTML = (new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(data.total_price * 0.05 / 100));
  //     document.getElementById('cartButton').disabled = false;
  //   document.getElementById('cartButtonInner').innerHTML = 'Zur Kasse';
  // }
  //  else if(data.item_count >= 12 && data.item_count < 18){
  //     document.getElementById('subtotalPrice').innerHTML = (new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(data.total_price * 0.93 / 100));
  //     document.getElementById('discountAmount').innerHTML = '7% Mengenrabatt';
  //     document.getElementById('discountPrice').innerHTML = (new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(data.total_price * 0.07 / 100));

  //     document.getElementById('cartButton').href = '/checkout';
  //   document.getElementById('cartButtonInner').innerHTML = 'Zur Kasse';
  // }
  //  else if(data.item_count >= 18){
  //     document.getElementById('subtotalPrice').innerHTML = (new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(data.total_price * 0.90/ 100));
  //     document.getElementById('discountAmount').innerHTML = '10% Mengenrabatt';
  //     document.getElementById('discountPrice').innerHTML = (new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(data.total_price * 0.1 / 100));
  //     document.getElementById('cartButton').href = '/checkout';
  //   document.getElementById('cartButtonInner').innerHTML = 'Zur Kasse';
  // }


  // if(data.item_count < 3){
  //   document.getElementById('cartButton').removeAttribute('href');
  //   document.getElementById('cartButton').classList.add('tw-opacity-50');
  //   document.getElementById('cartButtonInner').innerHTML = 'Mindestbestellmenge 3 Vowls';
  //   document.getElementById('subtotalPrice').innerHTML = (new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(data.total_price / 100));
  //   document.getElementById('discountAmount').innerHTML = '';
  //     document.getElementById('discountPrice').innerHTML = '';
  // }
  // else{
  //   document.getElementById('cartButton').setAttribute('href', '/checkout');
  //   document.getElementById('cartButton').classList.remove('tw-opacity-50');
  //   document.getElementById('cartButtonInner').innerHTML = 'Zur Kasse';
  //   document.getElementById('subtotalPrice').innerHTML = (new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(data.total_price / 100));
  // }
  // if(data.item_count <= 5){
  //   document.getElementById('subtotalPrice').innerHTML = (new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(data.total_price / 100));
  //   document.getElementById('discountAmount').innerHTML = '';
  //     document.getElementById('discountPrice').innerHTML = '';
  // }

});
await updateCartProgressBar();
}



async function addToCartPrepacked(itemsPrepacked, quantity){
  console.log(itemsPrepacked);
  // await fetch('/cart/clear.json', {
  //     method: "POST",
  //     headers: {
  //         "Accept": "application/json"
  //     }
  // });
  var items = [];
  itemsPrepacked.forEach(function(value) {
      items.push({
          quantity: quantity,
          id: value
      });
  });
  console.log(items)
  fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      body: JSON.stringify({
          items: items
      }),
      headers: {
          'Content-Type': 'application/json'
      }
  }).then(function(response) {
  }).then(function(data) {
  });
  await updateCart();
  setTimeout(openCart, 1000);
}

async function addToCartSpecial(itemid, quantity){
  var items = [];
  items.push({
    quantity: quantity,
    id: itemid
});

  fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
          items: items
      }),
      headers: {
          'Content-Type': 'application/json'
      }
  }).then(function(response) {
  }).then(function(data) {
  });
  await updateCart();
  setTimeout(openCart, 1000);
}


async function updateCartProgressBar(){
  var barCart = document.getElementById('vowlsCartMeter');
  var barCounter = 0;
  //fetch the cart and display the number of items in the cart as barCounter

      await fetch('/cart.js', {
      method: 'GET',
      headers: {
          'Content-Type': 'application/json',
      }
  })
  .then(response => response.json())
  .then(data => {
      console.log(data);

  if(data.item_count > 0){
      data.items.forEach(item => {
        if(item.id === 39309627654339){
          barCounter += 3 * item.quantity;
        }
        else if(item.id === 39400289927363){
          barCounter += 6 * item.quantity;
          console.log(barCounter);
        }
        else if(item.id === 39400300347587){
          barCounter += 12 * item.quantity;
        }
        else if(item.id === 39400309653699){
          barCounter += 18 * item.quantity;
        }
        else{
          barCounter += item.quantity;
        };
      });

      if (barCounter < 3){
        document.getElementById('milestoneCart').innerHTML= 'hinzu, um den Mindestbestellwert zu erreichen.';
        document.getElementById('vowlsLeftCart').innerHTML = `${3 -  barCounter }`
      }
      if (barCounter >= 3 && barCounter < 6){
        document.getElementById('milestoneCart').innerHTML= 'hinzu, um 5% Rabatt zu erhalten.';
        document.getElementById('vowlsLeftCart').innerHTML = `${6 -  barCounter }`
      }
      if (barCounter >= 6 && barCounter < 9){
        document.getElementById('milestoneCart').innerHTML= ' für kostenlosen Versand hinzu.';
        document.getElementById('vowlsLeftCart').innerHTML = `${9 -  barCounter }`
      }
      if (barCounter >= 9 && barCounter < 12){
        document.getElementById('milestoneCart').innerHTML= ' hinzu, um 7% Rabatt zu erhalten.';
        document.getElementById('vowlsLeftCart').innerHTML = `${12 -  barCounter }`
      }
      if (barCounter >= 12 && barCounter < 18){
        document.getElementById('milestoneCart').innerHTML= ' hinzu, um 10% Rabatt zu erhalten.';
        document.getElementById('vowlsLeftCart').innerHTML = `${18 -  barCounter }`
      }
      if (barCounter >= 18){
        document.getElementById('milestoneCart').innerHTML= ' hinzu, um 10% Rabatt zu erhalten.';
        document.getElementById('vowlsLeftCart').innerHTML = `0`
      }
  }
    document.getElementById('subtotalPrice').innerHTML = (new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(data.total_price / 100));
    if(data.original_total_price > data.total_price){
    document.getElementById('totalPrice').innerHTML = (new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(data.original_total_price / 100));
    } else {
      document.getElementById('totalPrice').innerHTML = '';
    }
  })
  barCart.value = barCounter;

}
function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              resolve(document.querySelector(selector));
              observer.disconnect();
          }
      });

      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}

